import * as React from 'react';

interface IconProps {
  className?: string;
}

export const ProfileIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.1341 9.05829C10.0508 9.04996 9.95078 9.04996 9.85911 9.05829C7.87578 8.99163 6.30078 7.36663 6.30078 5.36663C6.30078 3.32496 7.95078 1.66663 10.0008 1.66663C12.0424 1.66663 13.7008 3.32496 13.7008 5.36663C13.6924 7.36663 12.1174 8.99163 10.1341 9.05829Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.96758 12.1334C3.95091 13.4834 3.95091 15.6834 5.96758 17.025C8.25924 18.5584 12.0176 18.5584 14.3092 17.025C16.3259 15.675 16.3259 13.475 14.3092 12.1334C12.0259 10.6084 8.26758 10.6084 5.96758 12.1334Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TeacherIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.37526 2.10836L3.35859 5.38336C1.75026 6.43336 1.75026 8.78336 3.35859 9.83336L8.37526 13.1084C9.27526 13.7 10.7586 13.7 11.6586 13.1084L16.6503 9.83336C18.2503 8.78336 18.2503 6.4417 16.6503 5.3917L11.6586 2.1167C10.7586 1.5167 9.27526 1.5167 8.37526 2.10836Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.69193 10.9L4.68359 14.8084C4.68359 15.8667 5.50026 17 6.50026 17.3334L9.15859 18.2167C9.61693 18.3667 10.3753 18.3667 10.8419 18.2167L13.5003 17.3334C14.5003 17 15.3169 15.8667 15.3169 14.8084V10.9417"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.834 12.5V7.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PresentationChartIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.91719 14.1666H15.0755C16.6589 14.1666 17.4922 13.3333 17.4922 11.75V1.66663H2.49219V11.75C2.50052 13.3333 3.33386 14.1666 4.91719 14.1666Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.66602 1.66663H18.3327"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66602 18.3333L9.99935 16.6666V14.1666"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3333 18.3333L10 16.6667"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.25 9.16667L8.87499 6.975C9.08333 6.8 9.35833 6.85 9.49999 7.08333L10.5 8.75C10.6417 8.98333 10.9167 9.025 11.125 8.85834L13.75 6.66667"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ShopIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.50781 9.3501V13.0918C2.50781 16.8334 4.00781 18.3334 7.74948 18.3334H12.2411C15.9828 18.3334 17.4828 16.8334 17.4828 13.0918V9.3501"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0017 10.0001C11.5267 10.0001 12.6517 8.75841 12.5017 7.23341L11.9517 1.66675H8.06003L7.5017 7.23341C7.3517 8.75841 8.4767 10.0001 10.0017 10.0001Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.2596 10.0001C16.943 10.0001 18.1763 8.63341 18.0096 6.95841L17.7763 4.66675C17.4763 2.50008 16.643 1.66675 14.4596 1.66675H11.918L12.5013 7.50841C12.643 8.88341 13.8846 10.0001 15.2596 10.0001Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.70063 10.0001C6.07563 10.0001 7.3173 8.88341 7.45063 7.50841L7.63397 5.66675L8.03397 1.66675H5.4923C3.30897 1.66675 2.47563 2.50008 2.17563 4.66675L1.95063 6.95841C1.78397 8.63341 3.0173 10.0001 4.70063 10.0001Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0013 14.1667C8.60964 14.1667 7.91797 14.8584 7.91797 16.2501V18.3334H12.0846V16.2501C12.0846 14.8584 11.393 14.1667 10.0013 14.1667Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MessagesIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.9834 8.99167V12.325C14.9834 12.5417 14.9751 12.75 14.9501 12.95C14.7584 15.2 13.4334 16.3167 10.9918 16.3167H10.6584C10.4501 16.3167 10.2501 16.4167 10.1251 16.5833L9.12509 17.9167C8.68343 18.5083 7.96675 18.5083 7.52508 17.9167L6.52507 16.5833C6.41674 16.4417 6.17508 16.3167 5.99175 16.3167H5.65842C3.00009 16.3167 1.66675 15.6583 1.66675 12.325V8.99167C1.66675 6.55001 2.79176 5.22501 5.03342 5.03334C5.23342 5.00834 5.44176 5 5.65842 5H10.9918C13.6501 5 14.9834 6.33334 14.9834 8.99167Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.3168 5.65834V8.99167C18.3168 11.4417 17.1918 12.7583 14.9501 12.95C14.9751 12.75 14.9834 12.5417 14.9834 12.325V8.99167C14.9834 6.33334 13.6501 5 10.9918 5H5.65845C5.44178 5 5.23345 5.00834 5.03345 5.03334C5.22511 2.79167 6.55011 1.66667 8.99178 1.66667H14.3251C16.9834 1.66667 18.3168 3.00001 18.3168 5.65834Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.2462 11.0417H11.2537"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.32966 11.0417H8.33716"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.41292 11.0417H5.42042"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CallIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.3096 15.2751C18.3096 15.5751 18.243 15.8834 18.1013 16.1834C17.9596 16.4834 17.7763 16.7667 17.5346 17.0334C17.1263 17.4834 16.6763 17.8084 16.168 18.0167C15.668 18.2251 15.1263 18.3334 14.543 18.3334C13.693 18.3334 12.7846 18.1334 11.8263 17.7251C10.868 17.3167 9.90964 16.7667 8.95964 16.0751C8.0013 15.3751 7.09297 14.6001 6.2263 13.7417C5.36797 12.8751 4.59297 11.9667 3.9013 11.0167C3.21797 10.0667 2.66797 9.11675 2.26797 8.17508C1.86797 7.22508 1.66797 6.31675 1.66797 5.45008C1.66797 4.88341 1.76797 4.34175 1.96797 3.84175C2.16797 3.33341 2.48464 2.86675 2.9263 2.45008C3.45964 1.92508 4.04297 1.66675 4.65964 1.66675C4.89297 1.66675 5.1263 1.71675 5.33464 1.81675C5.5513 1.91675 5.74297 2.06675 5.89297 2.28341L7.8263 5.00841C7.9763 5.21675 8.08464 5.40841 8.15964 5.59175C8.23464 5.76675 8.2763 5.94175 8.2763 6.10008C8.2763 6.30008 8.21797 6.50008 8.1013 6.69175C7.99297 6.88341 7.83464 7.08341 7.63464 7.28341L7.0013 7.94175C6.90964 8.03341 6.86797 8.14175 6.86797 8.27508C6.86797 8.34175 6.8763 8.40008 6.89297 8.46675C6.91797 8.53341 6.94297 8.58341 6.95964 8.63341C7.10964 8.90841 7.36797 9.26675 7.73464 9.70008C8.10964 10.1334 8.50964 10.5751 8.94297 11.0167C9.39297 11.4584 9.8263 11.8667 10.268 12.2417C10.7013 12.6084 11.0596 12.8584 11.343 13.0084C11.3846 13.0251 11.4346 13.0501 11.493 13.0751C11.5596 13.1001 11.6263 13.1084 11.7013 13.1084C11.843 13.1084 11.9513 13.0584 12.043 12.9667L12.6763 12.3417C12.8846 12.1334 13.0846 11.9751 13.2763 11.8751C13.468 11.7584 13.6596 11.7001 13.868 11.7001C14.0263 11.7001 14.193 11.7334 14.3763 11.8084C14.5596 11.8834 14.7513 11.9917 14.9596 12.1334L17.718 14.0917C17.9346 14.2417 18.0846 14.4167 18.1763 14.6251C18.2596 14.8334 18.3096 15.0417 18.3096 15.2751Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M15.4167 7.49992C15.4167 6.99992 15.025 6.23325 14.4417 5.60825C13.9083 5.03325 13.2 4.58325 12.5 4.58325"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.3333 7.50008C18.3333 4.27508 15.725 1.66675 12.5 1.66675"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const HomeIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.04 6.82L14.28 2.79C12.71 1.69 10.3 1.75 8.78999 2.92L3.77999 6.83C2.77999 7.61 1.98999 9.21 1.98999 10.47V17.37C1.98999 19.92 4.05999 22 6.60999 22H17.39C19.94 22 22.01 19.93 22.01 17.38V10.6C22.01 9.25 21.14 7.59 20.04 6.82ZM12.75 18C12.75 18.41 12.41 18.75 12 18.75C11.59 18.75 11.25 18.41 11.25 18V15C11.25 14.59 11.59 14.25 12 14.25C12.41 14.25 12.75 14.59 12.75 15V18Z"
      fill="currentColor"
    />
  </svg>
);

export const HomeOutlineIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      transform="translate(-284 -144)"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="square"
      strokeLinejoin="round"
    >
      <path d="M293.02 146.84L287.63 151.04C286.73 151.74 286 153.23 286 154.36V161.77C286 164.09 287.89 165.99 290.21 165.99H301.79C304.11 165.99 306 164.09 306 161.78V154.5C306 153.29 305.19 151.74 304.2 151.05L298.02 146.72C296.62 145.74 294.37 145.79 293.02 146.84Z" />
      <path d="M296 161.99V158.99" />
    </g>
  </svg>
);

export const SearchIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M22 22L16 16"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AccountIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.1603 17.04C16.067 17.0266 15.947 17.0266 15.8403 17.04C13.4936 16.96 11.627 15.04 11.627 12.68C11.627 10.2666 13.5736 8.30664 16.0003 8.30664C18.4136 8.30664 20.3736 10.2666 20.3736 12.68C20.3603 15.04 18.507 16.96 16.1603 17.04Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.987 25.8401C22.6137 28.0134 19.467 29.3334 16.0003 29.3334C12.5337 29.3334 9.38701 28.0134 7.01367 25.8401C7.14701 24.5867 7.94701 23.3601 9.37367 22.4001C13.027 19.9734 19.0003 19.9734 22.627 22.4001C24.0537 23.3601 24.8537 24.5867 24.987 25.8401Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.0003 29.3334C23.3641 29.3334 29.3337 23.3639 29.3337 16.0001C29.3337 8.63628 23.3641 2.66675 16.0003 2.66675C8.63653 2.66675 2.66699 8.63628 2.66699 16.0001C2.66699 23.3639 8.63653 29.3334 16.0003 29.3334Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UserIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.6673 28C26.6673 26.1392 26.6673 25.2089 26.4377 24.4518C25.9206 22.7473 24.5867 21.4134 22.8822 20.8963C22.1251 20.6667 21.1947 20.6667 19.334 20.6667H12.6673C10.8066 20.6667 9.87619 20.6667 9.11913 20.8963C7.41459 21.4134 6.0807 22.7473 5.56364 24.4518C5.33398 25.2089 5.33398 26.1392 5.33398 28M22.0007 10C22.0007 13.3137 19.3144 16 16.0007 16C12.6869 16 10.0007 13.3137 10.0007 10C10.0007 6.68629 12.6869 4 16.0007 4C19.3144 4 22.0007 6.68629 22.0007 10Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CaretDownIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 9L12 15L18 9"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LockersIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="currentColor" strokeMiterlimit="10">
      <path d="M20.2602 19.561H4V3.62602C4 2.72801 4.72797 2.00001 5.62602 2.00001H18.6341C19.5322 2.00001 20.2602 2.72801 20.2602 3.62602V19.561Z" />
      <path d="M12.1301 2.00001V19.561" />
      <path d="M4 19.561V22" />
      <path d="M12.1301 19.561V22" />
      <path d="M20.2601 19.561V22" />
      <path d="M14.5691 8.50409H17.8211" />
      <path d="M14.5691 5.25208H17.8211" />
      <path d="M6.43903 8.50409H9.69106" />
      <path d="M6.43903 5.25208H9.69106" />
    </g>
    <path
      d="M9.69108 13.3821C9.69108 13.8311 9.3271 14.1951 8.87807 14.1951C8.42905 14.1951 8.06506 13.8311 8.06506 13.3821C8.06506 12.9331 8.42905 12.5691 8.87807 12.5691C9.3271 12.5691 9.69108 12.9331 9.69108 13.3821Z"
      fill="currentColor"
    />
    <path
      d="M17.8211 13.3821C17.8211 13.8311 17.4572 14.1951 17.0081 14.1951C16.5591 14.1951 16.1951 13.8311 16.1951 13.3821C16.1951 12.9331 16.5591 12.5691 17.0081 12.5691C17.4572 12.5691 17.8211 12.9331 17.8211 13.3821Z"
      fill="currentColor"
    />
  </svg>
);

export const HeartIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="12 8 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28.827 35.7466C28.3737 35.9066 27.627 35.9066 27.1737 35.7466C23.307 34.4266 14.667 28.92 14.667 19.5866C14.667 15.4666 17.987 12.1333 22.0803 12.1333C24.507 12.1333 26.6537 13.3066 28.0003 15.12C29.347 13.3066 31.507 12.1333 33.9203 12.1333C38.0137 12.1333 41.3337 15.4666 41.3337 19.5866C41.3337 28.92 32.6937 34.4266 28.827 35.7466Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ChevronRightIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.93994 13.28L10.2866 8.93333C10.7999 8.42 10.7999 7.58 10.2866 7.06667L5.93994 2.72"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowLeftIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 12H5M5 12L11 6M5 12L11 18"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const XIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 6L18 18M18 6L6 18"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BurgerIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 6H21M3 12H21M3 18H21"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BasketIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.5 7.5L12 3L15.5 7.5"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 8.5H21L19.4 18.2C19.18 19.55 18.02 20.5 16.66 20.5H7.34C5.98 20.5 4.82 19.55 4.6 18.2L3 8.5Z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <path
      d="M9.5 12V16M14.5 12V16"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </svg>
);

export const ChevronDownIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.92 8.95L13.4 15.47C12.63 16.24 11.37 16.24 10.6 15.47L4.08 8.95"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CartIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="12 8 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.333 27C23.333 29.56 25.4397 31.6667 27.9997 31.6667C30.5597 31.6667 32.6663 29.56 32.6663 27"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.7466 10.6667L18.9199 15.5067"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32.2529 10.6667L37.0796 15.5067"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.667 18.4667C14.667 16 15.987 15.8 17.627 15.8H38.3737C40.0137 15.8 41.3337 16 41.3337 18.4667C41.3337 21.3334 40.0137 21.1334 38.3737 21.1334H17.627C15.987 21.1334 14.667 21.3334 14.667 18.4667Z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M16.667 21.3333L18.547 32.8533C18.9737 35.4399 20.0003 37.3333 23.8137 37.3333H31.8537C36.0003 37.3333 36.6137 35.5199 37.0937 33.0133L39.3337 21.3333"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const SkvelkoIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 612 792"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M563.27,136.15l11.12-56.43c6.31-32.02-14.54-63.35-46.34-69.62C524.27,9.36,520.5,9,516.78,9
        c-27.59,0-52.5,19.71-58.11,47.91l-7.75,38.98c-4.02-4.57-8.21-9.01-12.57-13.29c-41.58-40.71-92.29-60.18-146.66-56.65
        C167.08,34.32,72.57,156.44,46.9,267.08c-24.28,104.66,9.02,194.69,89.08,240.84c58.14,33.51,126,19.86,185.87,7.78
        c95.41-19.23,109.01-13.07,121.55,19.46c10.29,26.68,1.05,63.08-23.54,92.71c-23.24,28.01-54.48,43.1-79.55,38.49
        c-16.57-3.06-31.44-14.9-45.47-34.33l-129.73-72.49l-7.47-4.07l42.53,147.89c0,0,0.01,0.05,0.01,0.06
        c27.81,37.89,66.14,69.12,118.74,78.83c10.01,1.85,20.14,2.76,30.32,2.76c58.36,0,118.04-29.73,161.31-81.87
        c52.19-62.89,68.59-143.5,42.81-210.36c-51.49-133.57-178.75-107.91-254.8-92.59c-39.42,7.95-84.11,16.95-103.73,5.65
        c-45.38-26.16-40.23-81.47-33.13-112.11c18-77.59,81.15-146.36,137.88-150.17c20.62-1.4,38.92,6.24,56.31,23.27
        c36.22,35.46,55.88,99.89,53.95,141.68l116.68,14.1l25.27-128.23l-0.1-0.1l10.6-54.17C562.65,138.8,563.01,137.49,563.27,136.15z
        M241.01,633.23l-31.96,21.5l-3,16.43l-15.89-53.67c5.99-10.57,13.01-15.42,23.97-17.01l49.51,32.25L241.01,633.23z M537.49,158.62
        l-76.86-15l2.52-12.94l76.86,15L537.49,158.62z M543.57,129.16l-76.86-15l2.52-12.94l76.86,15L543.57,129.16z M554.99,75.9
        l-4.58,23.22l-76.97-15.05l4.63-23.3c3.69-18.54,19.97-31.99,38.71-31.99c2.48,0,4.99,0.25,7.45,0.73
        c10.17,2,18.98,7.94,24.82,16.7C554.91,55.03,557.02,65.57,554.99,75.9z"
      fill="currentColor"
    />
  </svg>
);
